import { render, staticRenderFns } from "./QuizNavButtons.vue?vue&type=template&id=5ad9f4f7&scoped=true&"
import script from "./QuizNavButtons.vue?vue&type=script&lang=js&"
export * from "./QuizNavButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad9f4f7",
  null
  
)

export default component.exports